//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    getDetails(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.details).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    updateCompetitive(vue, competitive, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.updateCompetitive, { competitive }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    updateDonateModal(vue, hideDonateModal, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.updateDonateModal, { hideDonateModal }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getRuns(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.runs)
        .then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getCertificates(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.certificates)
        .then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getActiveCompetitions(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.activeCompetitions)
        .then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getTeam(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.team.details).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    leaveTeam(vue, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.leave, {}, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    search(vue, searchString, excludedTeam, cancelToken, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.search, {
            q: searchString,
            excludedTeam: excludedTeam,
        }, {
            cancelToken: cancelToken,
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getTeamInvites(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.teamInvites).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    acceptInvite(vue, inviteIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.acceptInvite, { identifier: inviteIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    acceptInviteMass(vue, inviteId, cb, errorCb, finallyCb) {
        // Backend expects `identifier` -- matches InviteLink.identifier, the
        // value generated by team.generateInviteLink()/inviteLinks(), not the
        // raw team identifier.
        axios.get(window.kgkRoutes.user.acceptInviteMass + "?identifier=" + inviteId).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));

    },
    acceptCompanyInviteMass(vue, inviteId, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.acceptCompanyInviteMass + "?identifier=" + inviteId).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));

    },

    declineInvite(vue, inviteIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.declineInvite, { identifier: inviteIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },


    changePassword(vue, newPassword, oldPassword, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.update, { mode: 'password', newPassword, oldPassword }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    changeMail(vue, email, currentPassword, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.update, { mode: 'email', email, password: currentPassword }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    update(vue, parameter, cb, errorCb, finallyCb) {
        parameter.mode = 'profile';

        axios.post(window.kgkRoutes.user.update, parameter, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    updateCompany(vue, parameter, cb, errorCb, finallyCb) {
        parameter.mode = 'company';

        axios.post(window.kgkRoutes.user.update, parameter, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getGroups(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.groups.list).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    searchGroups(vue, searchString, cancelToken, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.groups.search, {
            q: searchString,
        }, {
            cancelToken: cancelToken,
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    joinGroup(vue, groupIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.groups.join, {
            group: groupIdentifier,
        }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    leaveGroup(vue, groupIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.groups.leave, {
            group: groupIdentifier,
        }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    createGroup(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.groups.create, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    stravaAuthorize(vue, cb, errorCb, finallyCb, parameters) {
        axios.get(window.kgkRoutes.strava.authorize + parameters).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    stravaSyncronize(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.strava.syncronize).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    stravaDeauthorize(vue, cb, errorCb, finallyCb){
        axios.get(window.kgkRoutes.strava.deauthorize).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    stravaAcknowledgeAutoDisconnect(vue, cb, errorCb, finallyCb){
        axios.get(window.kgkRoutes.strava.acknowledgeAutoDisconnect).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    updateCompanyVerification(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.updateCompanyVerification, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    deleteAccount(vue, password, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.deleteAccount, { password }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    updateRunMode(vue, runMode, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.updateRunMode, { run_mode: runMode }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getPopupMessages(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.popupMessages)
        .then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    acknowledgePopupMessage(vue, id, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.acknowledgePopupMessage, { id }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
